export class FichasModel {
  id_ficha: number;
  id_cliente: number = null;
  id_importador: number = null;
  id_exportador: number = null;
  id_armador: number = null;
  id_terminal: number = null;
  id_despachante: number = null;
  id_pais_origem: number = null;
  id_viagem: number = null;
  id_transportador: number = null;
  id_mercadoria: number = null;
  id_variedade: number = null;
  id_embalagem: number = null;
  id_unidade: number = null;
  id_status: number = 1;
  numero: number;
  referencia: number;
  fatura: number;
  container: number;
  data_inspecao: number;
  conhecimento: number;
  marca: string;
  calibre: string;
  calibre_min: boolean = true;
  calibre_max: boolean = true;
  calibre_med: boolean = true;
  tamanho_calibre: string = null;
  odor: boolean = true;
  lote: string;
  pressao_polpa: any = [];
  pressao_poupa_status: boolean = true;
  pressao_polpa_exibir: boolean = true;
  brix: any = [];
  brix_status: boolean = true;
  brix_exibir: boolean = true;
  em_conformidade: boolean = true;
  paletizacao: boolean = true;
  paletizacao_exibir: boolean = true;
  temperatura_polpa_exibir: boolean = true;
  calibre_exibir: boolean = true;
  peso_liquido_vol: boolean = true;
  sem_pesagem: boolean = false;
  pesagem: any = [];
  embalagem_avariada: boolean = false;
  rotulo_divergente: boolean = false;
  carga_avancada: boolean = false;
  sem_rotulo: boolean = false;
  carga_tombada_porta: boolean = false;
  carga_avancada_teto: boolean = false;
  estivagem: boolean = true;
  observacoes = [];
  conclusoes = [];
  defeitos = [];
  protestos = [];
  setpoint: string;
  setpoint_off: any;
  airtemperature: string;
  airtemperature_off: any;
  ventilacao_bl: string;
  ventilacao_bl_fechado: any;
  temperatura_bl: string;
  temperaturas_polpa: any = [];
  temperatura_polpa_status: boolean = true;
  termografos: any = [];
  avaria_interna_container: string;
  avaria_externa_container: string;
  lacre_origem: string;
  lacre_fechamento: string;
  indices_conclusao;
  tipo_categoria_rotulo: string;
  data_fabricacao: string;
  data_validade: string;
  ventilacao_container: any;
  sem_ventilacao_container: boolean;
  ventilacao_container_automatico: boolean;
  ventilacao_container_unidade: string = '628351754816228137';
  ventilacao_bl_unidade: string = '628351754816228137';
  id_coloracao: string;
  protesto: boolean;
  is_dry: boolean = false;
  fatura_gerada: any;
  responsaveis_tecnicos: any = [];
  comentarios_exibir: boolean = false;
  comentarios_pt: string;
  comentarios_en: string;
  comentarios_es: string;
  comentarios_cor: number = null;
}



// WEBPACK FOOTER //
// ./src/app/fichas/fichas.model.ts